module.exports = __webpack_public_path__ + "static/media/3b.f94b75bb.jpg";